import { SubscriptionTier, CreateSubscriptionTierInput, UpdateSubscriptionTierInput } from '../types/subscriptionTier';
import { createAuthRequestInit } from '../utils/auth';
import { API_BASE } from '../config/api';

// GET /api/tiers - list all active tiers (public)
// GET /api/tiers?all=true - list all tiers including inactive (requires auth)
export async function getTiers(all?: boolean): Promise<SubscriptionTier[]> {
  const url = `${API_BASE}/tiers${all ? '?all=true' : ''}`;
  const res = await fetch(url, all ? createAuthRequestInit() : undefined);
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(errorText || 'Failed to fetch subscription tiers');
  }
  const json = await res.json();
  return json.data.tiers as SubscriptionTier[];
}

// GET /api/tiers/:id - get single tier (public)
export async function getTier(id: string): Promise<SubscriptionTier> {
  const url = `${API_BASE}/tiers/${encodeURIComponent(id)}`;
  const res = await fetch(url);
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(errorText || `Failed to fetch subscription tier (${res.status})`);
  }
  const json = await res.json();
  return json.data.tier as SubscriptionTier;
}

// POST /api/tiers - create new tier (super admin only)
export async function createTier(tier: CreateSubscriptionTierInput): Promise<SubscriptionTier> {
  const res = await fetch(
    `${API_BASE}/tiers`,
    createAuthRequestInit(
      {
        method: 'POST',
        body: JSON.stringify(tier)
      },
      true
    )
  );
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(errorText || 'Failed to create subscription tier');
  }
  const json = await res.json();
  return json.data.tier as SubscriptionTier;
}

// PUT /api/tiers/:id - update tier (super admin only)
export async function updateTier(id: string, tier: UpdateSubscriptionTierInput): Promise<SubscriptionTier> {
  const res = await fetch(
    `${API_BASE}/tiers/${encodeURIComponent(id)}`,
    createAuthRequestInit(
      {
        method: 'PUT',
        body: JSON.stringify(tier)
      },
      true
    )
  );
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(errorText || 'Failed to update subscription tier');
  }
  const json = await res.json();
  return json.data.tier as SubscriptionTier;
}

// DELETE /api/tiers/:id - delete tier (super admin only, soft delete)
export async function deleteTier(id: string): Promise<void> {
  const res = await fetch(
    `${API_BASE}/tiers/${encodeURIComponent(id)}`,
    createAuthRequestInit({
      method: 'DELETE'
    })
  );
  if (!res.ok && res.status !== 204) {
    const errorText = await res.text();
    throw new Error(errorText || 'Failed to delete subscription tier');
  }
}

